// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"337":"f7e12d74","384":"84280fe8","571":"b81da29a","838":"4e6f02bc"}[chunkId] + ".chunk.css";
};